<template>
  <div>
    <div v-if="!isFinished" class="actions">
      <div class="side-by-side">
        <Button key="cancel" title="Cancelar" type="danger" size="small" :disabled="processing || selected.length === 0"
          :clicked="hideModal" />
        <Button key="ok" title="Processar" color="white" classIcon="fa-solid fa-play" backGroundColor="#007BFF"
          size="large" :disabled="processing || selected.length === 0" :clicked="ok" />
      </div>
    </div>

    <div v-else class="text-center">
      <Timer v-if="errorCount === 0" :title="'Fechando em'" :initialTimer="2" :endTime="autoFinished" />
      <div v-if="errorCount > 0" class="side-by-side">
        <Button v-if="canGoBack" key="back" title="Voltar" classIcon="fa-solid fa-rotate-left" color="white"
          backGroundColor="#6D757B" size="medium" :clicked="back" />
        <Button key="finish" title="Fechar" classIcon="fa-solid fa-circle-xmark" color="white"
          backGroundColor="#6D757B" size="medium" :clicked="finished" />
      </div>
      <Button v-else key="finish" title="Fechar" classIcon="fa-solid fa-circle-xmark" color="white"
        backGroundColor="#6D757B" size="medium" :clicked="finished" />
    </div>
  </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import Timer from "@/ui/shared/Timer";

export default {
  name: "ActionFooter",
  components: { Button, Timer },
  props: {
    isFinished: { type: Boolean, default: false },
    processing: { type: Boolean, default: false },
    selected: { type: Array, default: () => [] },
    errorCount: { type: Number, default: 0 },
    canGoBack: { type: Boolean, default: false },
  },
  emits: ["ok", "cancel", "finish", "back"],
  methods: {
    ok() {
      this.$emit("ok");
    },
    hideModal() {
      this.$emit("cancel");
    },
    autoFinished() {
      this.finished();
    },
    finished() {
      this.$emit("finish");
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>

<style scoped>
.actions {
  text-align: center;
}

.side-by-side {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
</style>
